export type CurrencyType = {
  countryName: string;
  countryCode: string;
  currencyCode: string;
  currencyRate: string;
  id: string;
};

export type CurrencyState = {
  loading: boolean;
  error: Error;
  currency: object;
  selectedFy: string;
};

export const initialState = {
  loading: false,
  error: null,
  currency: {},
  selectedFy: '',
};
